import { CreationProject } from "../../../stores/project/project";
import * as React from "react";
import {
    Divider,
    Grid,
    GridColumn,
    List,
    ListItem,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow
} from "semantic-ui-react";
import "./area-data-creation-project.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import editIcon from "../../../assets/images/icons/plain/pencil.svg";
import locateIcon from "../../../assets/images/icons/plain/map_location2.svg";
import expandIcon from "../../../assets/images/icons/plain/navigate_close.svg";
import collapseIcon from "../../../assets/images/icons/plain/navigate_open.svg";
import SVG from "react-inlinesvg";
import { AppState } from "../../../stores/app-mobx";
import { Constants } from "../../../globals/constants";
import TruncatedText from "../../../components/truncated-text/truncated-text";
import { getDesc, getLabel } from "../../../reflection/reflection";
import DescribedLabel from "../../../components/described-label/described-label";
import { UsageArea } from "../../../stores/area/area";

export default function AreaDataCreationProject({
                                                    project,
                                                    appStore
                                                }: { project: CreationProject, appStore: AppState }): JSX.Element {
    function expandOrCollapseArea(areaId: number) {
        if (expandedArea === areaId) {
            setExpandedArea(undefined);
        } else {
            setExpandedArea(areaId);
        }
    }

    function expandOrCollapseUsageProjects() {
        setExpandedUsageProjects(!expandedUsageProjects);
    }

    const [expandedArea, setExpandedArea] = useState<number | undefined>(undefined);
    const [expandedUsageProjects, setExpandedUsageProjects] = useState<boolean>(false);

    const areaRows: any[] = [];
    for (const a of project.areas) {
        areaRows.push(
            <TableRow key={a.id} onClick={() => expandOrCollapseArea(a.id)}>
                <TableCell>
                    {expandedArea === a.id ?
                        <SVG src={collapseIcon} height="auto" width={15} title="Zuklappen"/> :
                        <SVG src={expandIcon} height="auto" width={15} title="Aufklappen"/>}
                </TableCell>
                <TableCell textAlign="right">{a.id}</TableCell>
                <TableCell textAlign="right">{a.nek === 2 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 3 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 4 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 5 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 6 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.nek === 99 ? a.areaRounded.toLocaleString() : 0}</TableCell>
                <TableCell textAlign="right">{a.eligibilityDisplayText}</TableCell>
                <TableCell textAlign="right">{a.effectiveAreaRounded.toLocaleString()}</TableCell>
            </TableRow>
        );

        if (a.id === expandedArea) {
            areaRows.push(
                <TableRow key={-2}>
                    <TableCell colSpan={10}>
                        <div className="areaData">
                            <div>
                                <span onClick={() => {
                                    appStore.setAreaId(a.project.categoryKey, a.projectId, a.id);
                                    window.scrollTo({ top: 0, behavior: "instant" });
                                }}>
                                    <SVG src={locateIcon} height="auto"
                                         width={20} title="Fokus"/>
                                </span>
                                <Link to={`flaechen/${Constants.projectCategoryCreation}/${a.id}/aendern`}
                                      preventScrollReset={true}>
                                    <SVG src={editIcon} height="auto" width={20} title="Fläche editieren"/>
                                </Link>
                            </div>
                            <List>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "stage")} desc={getDesc(a, "stage")}/>: {a.stage}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "pngDisplayText")}
                                                    desc={getDesc(a, "pngDisplayText")}/>: {a.pngDisplayText}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "nek")} desc={getDesc(a, "nek")}/>: {a.nek}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "eligibilityDisplayText")}: {a.eligibilityDisplayText}
                                </ListItem>
                            </List>
                            <List>
                                <ListItem>
                                    {getLabel(a, "creationStatus")}: {a.creationStatus}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "soilWorkStartDateDisplayText")}: {a.soilWorkStartDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "soilWorkEndDateDisplayText")}: {a.soilWorkEndDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "afterSoilApplicationAcceptanceDateDisplayText")}: {a.afterSoilApplicationAcceptanceDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "cultivationEndDateDisplayText")}: {a.cultivationEndDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "afterCultivationAcceptanceDateDisplayText")}: {a.afterCultivationAcceptanceDateDisplayText}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "remarksProjectStatus")}: <TruncatedText text={a.remarksProjectStatus}/>
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterSoilApplicationDocStatus")}
                                                    desc={getDesc(a, "afterSoilApplicationDocStatus")}/>: {a.afterSoilApplicationDocStatus}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterSoilApplicationDocSource")}
                                                    desc={getDesc(a, "afterSoilApplicationDocSource")}/>: {a.afterSoilApplicationDocSource}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterCultivationDocStatus")}
                                                    desc={getDesc(a, "afterCultivationDocStatus")}/>: {a.afterCultivationDocStatus}
                                </ListItem>
                                <ListItem>
                                    <DescribedLabel label={getLabel(a, "afterCultivationDocSource")}
                                                    desc={getDesc(a, "afterCultivationDocSource")}/>: {a.afterCultivationDocSource}
                                </ListItem>
                                <ListItem>
                                    {getLabel(a, "remarksDocumentation")}: <TruncatedText
                                    text={a.remarksDocumentation}/>
                                </ListItem>
                            </List>
                        </div>
                    </TableCell>
                </TableRow>
            );
        }
    }

    let usageProjects = null;

    if (expandedUsageProjects) {
        usageProjects = <Table basic="very" compact="very" size="small">
            <TableHeader>
                <TableRow>
                    <TableHeaderCell></TableHeaderCell>
                    <TableHeaderCell>{getLabel(CreationProject.prototype, "fullType")}</TableHeaderCell>
                    <TableHeaderCell>{getLabel(CreationProject.prototype, "municipalityName")}</TableHeaderCell>
                    <TableHeaderCell>{getLabel(CreationProject.prototype, "status")}</TableHeaderCell>
                    <TableHeaderCell></TableHeaderCell>
                </TableRow>
            </TableHeader>
            <TableBody>
                {project.compensations.map(c =>
                    <TableRow key={c.id}>
                        <TableCell verticalAlign="middle">
                            <div className="projectLinks">
                            <span onClick={() => {
                                appStore.setProjectId(c.usageProject.categoryKey, c.usageProjectId, true);
                                window.scrollTo({ top: 0, behavior: "instant" });
                            }}>
                                <SVG src={locateIcon}
                                     height="auto" width={20}
                                     title="Fokus"/>
                            </span>
                                <Link
                                    to={`/projekte/${Constants.projectCategoryUsage}/${c.usageProjectId}`}>{c.usageProject.name} ({c.usageProjectId})</Link>
                            </div>
                        </TableCell>
                        <TableCell>{c.usageProject.type}</TableCell>
                        <TableCell>{c.usageProject.municipalityName}</TableCell>
                        <TableCell>{c.usageProject.status}</TableCell>
                        <TableCell textAlign="right">{c.area?.toLocaleString()}</TableCell>
                    </TableRow>)}
            </TableBody>
        </Table>;
    }

    return (
        <div className="areaDataCreationProject">
            <Grid columns={1}>
                <GridColumn>
                    <Table compact="very" basic="very" size="small" columns={10}>
                        <TableHeader>
                            <TableRow className="tableHeader">
                                <TableHeaderCell></TableHeaderCell>
                                <TableHeaderCell textAlign="right">ID</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK2")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK3")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK4")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK5")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEK6")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "areaNEKUnknown")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">{getLabel(UsageArea.prototype, "eligibilityDisplayText")}</TableHeaderCell>
                                <TableHeaderCell textAlign="right">TOTAL</TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {areaRows}
                            <TableRow className="italic">
                                <TableCell>TOTAL Neuschaffung</TableCell>
                                <TableCell></TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek2.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek3.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek4.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek5.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNek6.toLocaleString()}</TableCell>
                                <TableCell textAlign="right">{project.totalAreaNekUnknown.toLocaleString()}</TableCell>
                                <TableCell></TableCell>
                                <TableCell textAlign="right">{project.totalEffectiveAreaCreated.toLocaleString()}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <br/>
                    {project.compensations.length > 0 &&
                    <>
                        <Table className="tableWithNoBorder" compact="very" basic="very" size="small" columns={4}>
                            <TableBody>
                                <TableRow className="italic" onClick={() => expandOrCollapseUsageProjects()}>
                                    <TableCell verticalAlign="middle">
                                        <span>TOTAL Beanspruchung </span>{expandedUsageProjects ?
                                        <SVG src={collapseIcon} height="auto" width={15} title="Zuklappen"/> :
                                        <SVG src={expandIcon} height="auto" width={15} title="Aufklappen"/>}
                                    </TableCell>
                                    <TableCell colSpan={2}></TableCell>
                                    <TableCell textAlign="right">{project.totalAreaClaimed.toLocaleString()}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        {usageProjects}
                    </>}
                    {project.compensations.length <= 0 &&
                    <Table className="tableWithNoBorder" basic="very" compact="very" size="small" columns={2}>
                        <TableBody>
                            <TableRow className="italic">
                                <TableCell>TOTAL Beanspruchung</TableCell>
                                <TableCell colSpan={2}></TableCell>
                                <TableCell textAlign="right">{project.totalAreaClaimed.toLocaleString()}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>}
                    <Divider/>
                    <Table compact="very" basic="very" size="small" columns={2}>
                        <TableBody>
                            <TableRow className="italic">
                                <TableCell>Gesamtbilanz</TableCell>
                                <TableCell textAlign="right">
                                    {project.totalAreaAvailable > 0
                                        ? <span
                                            style={{ color: "green" }}>{project.totalAreaAvailable.toLocaleString()}</span>
                                        : project.totalAreaAvailable === 0
                                            ? project.totalAreaAvailable.toLocaleString()
                                            : <span
                                                style={{ color: "red" }}>{project.totalAreaAvailable.toLocaleString()}</span>
                                    }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </GridColumn>
            </Grid>
        </div>
    );
}